import {Platform} from 'react-native';
import {createSelector} from 'reselect';
import {AppState} from '../..';

export const netInfoSelector = () =>
  createSelector(
    (state: AppState) => state.httpWrapper.netInfo,
    (item) => item,
  );

export const requestsErrorSelector = () =>
  createSelector(
    (state: AppState) => state.httpWrapper.netInfo.hasTrackedRequestError,
    (item) => item,
  );

export const isInternetReachableSelector = () =>
  createSelector(
    (state: AppState) => state.httpWrapper.netInfo,
    (netInfo) => {
      if (!netInfo.isDetected) {
        return null;
      }
      return Platform.OS === 'web' ? !!netInfo.isConnected : !!netInfo.isInternetReachable;
    },
  );
